import { NgModule } from '@angular/core';
import player from 'lottie-web';
import { provideLottieOptions } from 'ngx-lottie';

export function playerFactory() {
	return player;
}

@NgModule({
	providers: [provideLottieOptions({ player: playerFactory })],
})
export class AppLottieModule {}
